// Ionic & Angular Imports
import {Component} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Events, AlertController, PopoverController, ViewController, NavController,
        NavParams, LoadingController, Loading} from 'ionic-angular';

// Service Imports
import {rsReportSvc, ReportState} from '../../../../services/report.service';

// Component Imports
import {BasePage} from '../../../base.component';

@Component({
    templateUrl: 'order.html',
})
export class OrderPage extends BasePage
{
    // Class member variables
    private modalForm       : FormGroup;
    private initOrders      : string;

    constructor( 
        protected alertCtrl : AlertController,
        private navCtrl : NavController,
        private navParams : NavParams, 
        private reportSvc: rsReportSvc, 
        private loadingCtrl : LoadingController,
        private viewCtrl : ViewController,
        private formBuilder : FormBuilder,
        private popupCtrl : PopoverController,
        private eventSystem : Events
    ){
        // Construct base class
        super( alertCtrl );

        // Retrieve modal data from NavParams           
        this.initOrders = <string>this.navParams.get("content");

        // Build our form model structure
        this.buildFormModel();
    }

    // Class method for builidng our form model structure 
    private buildFormModel() {
        this.modalForm = this.formBuilder.group({
            orders:      [this.initOrders]
        });
    }

    public modalReset() {
        this.modalForm.reset( {
            orders:      this.initOrders
        });
    }

    public modalSubmit( formData : any, isValid : boolean ) {
        // Display a loader while the modal submits our changes
        let loader : Loading = this.loadingCtrl.create({
            content: 'Updating...',
            dismissOnPageChange: true
        });
        loader.present().then( () => {
            // Determine what the submit button shoudl be doing based on the validity
            // of the form and the mode of the modal.
            if( isValid === true) {
                this.reportSvc.updateOrdersReceived( this.reportSvc.getActiveReportId(), formData.orders ).subscribe( result => {
                    this.eventSystem.publish('report:updated', ReportState.OrdersReceived, result );
                }, err => {
                    // Operation failed; dismiss loader and display an error message
                    loader.dismiss().then( () => {
                        this.displayError("There was an error updating the report.  Please try again later." );
                    });
                }, () => {
                    // Operation complete, let's navigate back
                    this.navCtrl.pop();
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/report/tab-main/order/order.component.ts